import React from 'react';
import { JustifyContents, Alignment, Wraps, FlexDirections } from '../models/index';
import '../../styles/global/global.scss';
interface BlockInputProps {
    justifyContent?: JustifyContents;
    alignItems?: Alignment;
    gap?: number;
    proportion?: number;
    className?: string;
    overflow?: string;
}

export const BlockInput = (props: React.PropsWithChildren<BlockInputProps>) => {
    return (
        <div
            className={'flex' + (props.className ? ' ' + props.className : '')}
            style={{
                justifyContent: props.justifyContent,
                alignItems: props.alignItems,
                flexWrap: Wraps.noWrap,
                flexDirection: FlexDirections.column,
                rowGap: props.gap || 15,
                columnGap: props.gap || 30,
                flex: props.proportion || 1,
                overflow: props.overflow,
            }}
        >
            {props.children}
        </div>
    );
};
